import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import { processPath } from "@/services/backend/processes/lib/process-path";
import { DocumentKind, ServiceKind } from "@bitory-gmbh/bsm";

export interface UseDocumentPathParams {
  documentId: string;
  documentKind: DocumentKind;
  /** serviceKind is the kind of the process, null for an omni process. */
  serviceKind: ServiceKind | null;
  processId: string | null;
}

export interface UseDocumentPathReturn {
  path: string | null;
}

export function useDocumentPath({
  documentId,
  documentKind,
  serviceKind,
  processId,
}: UseDocumentPathParams): UseDocumentPathReturn {
  if (!processId) {
    // If no processId is provided, we cannot create a valid path.
    return { path: null };
  }
  const akPath = documentKindPath(documentKind);
  const path = `${processPath(serviceKind, processId)}/${akPath}/${documentId}`;

  return { path };
}

function documentKindPath(documentKind: DocumentKind): string {
  if (documentKind === GSMDocumentKind.WorkOrder) {
    return "work-orders";
  }

  return `${documentKind}s`;
}
